/**
 * Search params constants
 * @type {string}
 */
export const UPDATE_PARAMS = 'ideal/components/Search/UPDATE_PARAMS';
export const REMOVE_PARAM = 'ideal/components/Search/REMOVE_PARAM';
export const RESET_PARAMS = 'ideal/components/Search/RESET_PARAMS';

export const FILTERS_RECEIVED =
  'ideal/components/Search/FILTERS_RECEIVED';
export const GET_FILTERS = 'ideal/components/Search/GET_FILTERS';
export const SET_LOADING = 'ideal/components/Search/SET_LOADING';
export const UNSET_LOADING = 'ideal/components/Search/UNSET_LOADING';

export const FILTERS_ALLOWED = [
  'brands',
  'brokers',
  'catalogo',
  'categories',
  'delivery_time',
  'fast_delivery',
  'deposit',
  'distance',
  'duration',
  'fuels',
  'gear',
  'monthly_rate',
  'noviceDriver',
  'piva',
  'privati',
  'products',
  'stocks',
  'areas',
]

export const FILTERS_LABELS = {
  'brands': 'Marca',
  'brokers': 'Provider',
  'catalogo': 'Offerte catalogo',
  'categories': 'Categoria',
  'delivery_time': 'Tempi di consegna',
  'fast_delivery': 'Consegna veloce',
  'deposit': 'Anticipo',
  'distance': 'Km/anno',
  'duration': 'Durata',
  'fuels': 'Alimentazione',
  'gear': 'Cambio',
  'kwh': 'Capacità batteria',
  'monthly_rate': 'Rata',
  'noviceDriver': 'Solo per neopatentati',
  'piva': 'P.IVA',
  'privati': 'Privati',
  'products': 'Prodotti',
  'stocks': 'Disponibilità',
  'areas': 'Area',
}

export const FILTERS_LABELS_SHORT = {
  'delivery_time': 'Consegna',
}

export const FILTERS_AS_TAG = [
  'piva',
  'privati',
  'noviceDriver',
  'catalogo',
  'fast_delivery',
]
